import { inject, Injectable } from '@angular/core';
import { TenantDetailDto } from '@flexyoo/api/models';
import { IAutocompleteSearchResult } from '@flexyoo/shared/models';
import { ITenantAutocompleteSearchApiService } from '@flexyoo/shared/ui';
import { TenantGroupHomeDataAccessService } from '@flexyoo/tenant-group/data-access';
import { BehaviorSubject, combineLatest, map, Observable, shareReplay } from 'rxjs';

@Injectable()
export class TenantGroupPossibleTenantsAutocompleteSearchService
  implements ITenantAutocompleteSearchApiService
{
  private readonly tenantsList$ = inject(TenantGroupHomeDataAccessService)
    .getTenantGroupPossibleTenantsList()
    .pipe(shareReplay({ refCount: true, bufferSize: 1 }));

  public readonly selectedTenant$ = new BehaviorSubject<TenantDetailDto[]>([]);

  public readonly list$ = combineLatest([this.tenantsList$, this.selectedTenant$]).pipe(
    map(([list, selectedTenant]) => [...list, ...selectedTenant]),
    shareReplay({ refCount: true, bufferSize: 1 })
  );

  public search(value: string): Observable<IAutocompleteSearchResult[]> {
    return this.list$.pipe(
      map((data) =>
        (data ?? [])
          .filter((t) => t.Name?.toLowerCase()?.includes((value ?? '')?.toLowerCase()))
          .map((item) => ({ id: item.Id, name: item.Name }))
      )
    );
  }
}
